// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2oW47","footerText":"footer_footerText__2gc9j","companyName":"footer_companyName__1Ct7B"};